import * as ActionGenerics from "../../Common/actionGenerics";
import * as ActionTypes from "./actionTypes";
import * as StoreTypes from "../DataTypes/storeTypes";
import * as Fetch from "../../Common/fetch";
import * as ClientTypes from "../DataTypes/clientTypes";
import * as Notifications from "../../Common/Notifications/helper";
import { Step } from "../DataTypes/storeTypes";

export function selectClient(id: number) {
    return { type: ActionTypes.Actions.SelectClient, parameter: id };
}

export function getClients(dispatch, state: StoreTypes.IStore) {
    const providerInfo = state.stepsInfo[Step.Provider];

    return Fetch.post<ClientTypes.IClient[]>(state.initialSettings.getClientsUrl, {
        practitionerId: providerInfo.id,
        type: StoreTypes.BookingType[state.initialSettings.type],
    })
        .then((data) => dispatch(updateClients(data)))
        .catch((data) => Notifications.error(data.message));
}

function updateClients(
    clients: ClientTypes.IClient[]
): ActionGenerics.IParamAction<ActionTypes.Actions, ClientTypes.IClient[]> {
    return { type: ActionTypes.Actions.UpdateClients, parameter: clients };
}
